// extracted by mini-css-extract-plugin
export default {"statusCell__tag":"StatusCell_statusCell__tag__egGET"};